import React, { useState } from "react";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, CircularProgress, Box } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Line,
} from "recharts";
import { useNavigate } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { useGetDashboardGraphQuery, useGetRevenueGraphQuery } from "../../service/features/api";


function ManageAnalytics() {

  const navigate = useNavigate();
  const [userPeriod, setUserPeriod] = useState("monthly");

  const { data: userDataResponse, isFetching: isFetchingUsers } = useGetDashboardGraphQuery({
    period: userPeriod,
    graphType: "user",
  });

  const userData = userDataResponse?.data || [];

  const [revenuePeriod, setRevenuePeriod] = useState("monthly");

  const { data: revenueDataResponse, isFetching: isFetchingRevenue } = useGetRevenueGraphQuery({
    period: revenuePeriod,
  });

  const revenueGraphData = revenueDataResponse?.data || [];

  return (
    <>
      <CommonBreadcrumb
        title="Revenue & Analytics / الإيرادات والتحليلات"
        breadcrumbItems={[
          { label: "Dashboard / لوحة المعلومات", onClick: () => navigate("/dashboard") },
          { label: "Revenue & Analytics / الإيرادات والتحليلات" },
        ]}
      />

      {/* CHARTS */}
      <div className="grid_sc gap_m">
        {/* TOTAL USERS */}
        <div className="cards table_card">
          <div className="cards_header mb_20">
            <div className="left_s">
              <h2>Total Users / إجمالي المستخدمين</h2>
            </div>
            <div className="right_s">
              <p className="period_filters">
                <span
                  className={userPeriod === "daily" ? "active" : ""}
                  onClick={() => setUserPeriod("daily")}
                >
                  A day / يوم
                </span>
                <span
                  className={userPeriod === "weekly" ? "active" : ""}
                  onClick={() => setUserPeriod("weekly")}
                >
                  A week / أسبوع
                </span>
                <span
                  className={userPeriod === "monthly" ? "active" : ""}
                  onClick={() => setUserPeriod("monthly")}
                >
                  A month / شهر
                </span>
                <span
                  className={userPeriod === "yearly" ? "active" : ""}
                  onClick={() => setUserPeriod("yearly")}
                >
                  A year / سنة
                </span>
              </p>
            </div>
          </div>

          <Box sx={{ position: 'relative', height: 320 }}>
            {isFetchingUsers && (
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.5)'
              }}>
                <CircularProgress />
              </Box>
            )}
            <ResponsiveContainer width="100%" height={320}>
              <BarChart data={userData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="label" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="users" fill="#38B6FF" name="Customers / العملاء" />
                <Bar dataKey="dealers" fill="#FF9F40" name="Dealers/Sellers / الوكلاء/البائعون" />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </div>

        {/* TOTAL REVENUE */}
        <div className="cards table_card">
          <div className="cards_header mb_20">
            <div className="left_s">
              <h2>Total Revenue / إجمالي الإيرادات</h2>
            </div>
            <div className="right_s">
              <p className="period_filters">
                <span
                  className={revenuePeriod === "daily" ? "active" : ""}
                  onClick={() => setRevenuePeriod("daily")}
                >
                  A day / يوم
                </span>
                <span
                  className={revenuePeriod === "weekly" ? "active" : ""}
                  onClick={() => setRevenuePeriod("weekly")}
                >
                  A week / أسبوع
                </span>
                <span
                  className={revenuePeriod === "monthly" ? "active" : ""}
                  onClick={() => setRevenuePeriod("monthly")}
                >
                  A month / شهر
                </span>
                <span
                  className={revenuePeriod === "yearly" ? "active" : ""}
                  onClick={() => setRevenuePeriod("yearly")}
                >
                  A year / سنة
                </span>
              </p>
            </div>
          </div>

          <Box sx={{ position: 'relative', height: 320 }}>
            {isFetchingRevenue && (
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.5)'
              }}>
                <CircularProgress />
              </Box>
            )}
            <ResponsiveContainer width="100%" height={320}>
              <LineChart data={revenueGraphData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="label" />
                <YAxis />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#38B6FF"
                  strokeWidth={3}
                  name="Revenue / الإيرادات"
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        </div>
      </div>
    </>
  );
}

export default ManageAnalytics;
